// ==========================================================================
// Plyr Polyfilled Build
// plyr.js v3.6.3
// https://github.com/sampotts/plyr
// License: The MIT License (MIT)
// ==========================================================================

import 'custom-event-polyfill';
import 'url-polyfill';

(function (arr) {
    arr.forEach(function (item) {
      if (item.hasOwnProperty('remove')) {
        return;
      }
      Object.defineProperty(item, 'remove', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function remove() {
          if (this.parentNode !== null)
            this.parentNode.removeChild(this);
        }
      });
    });
  })([Element.prototype, CharacterData.prototype, DocumentType.prototype]);
  
import Plyr from './starplyr';

export default Plyr;
